import { Container } from "react-bulma-components";
import styled from "styled-components";

const ContainerFullWidth = styled(Container)`
    width: 100%;
`;

export default ContainerFullWidth;
